module.exports = __webpack_public_path__ + "img/Symbol_L1.dfc0c72c.png";